<template>
  <div>

    <!-- title and buttons-->
    <div class="flex justify-between items-center mb-4">
      <h5 v-if="title" class="flex items-center"><i class="dot"></i>{{ title }}</h5>
      <div v-if="buttons && !readonly && !isPrint">
        <vs-button
          v-for="button in buttons" :key="`${id}_${button.key}`"
          class="ml-4"
          v-bind="button.props"
          @click="handleClick(button.key)"
        > {{ button.label }} </vs-button>
      </div>
    </div>

    <div>
      <slot v-for="data in value" :data="data" />
    </div>

    <!-- footer -->
    <slot name="foot"></slot>
  </div>
</template>

<script>
export default {
  name: "ItemListEditor",
  props: {
    title: String,
    readonly: Boolean,
    isPrint: Boolean,
    checkedKey: {
      type: String,
      default: 'isChecked'
    },
    buttons: {
      type: Array,
      default: () => {
        return [
          { "label": '항목추가', "key": 'add', "props": { "color": "secondary", "type": "border" } },
          { "label": '선택삭제', "key": 'delete', "props": { "color": "secondary"} },
        ]
      }
    },
    value: Array,
  },
  data () {
    return {
      id: new Date().getTime()
    }
  },
  methods: {
    handleClick(key) {
      if (key === 'add') {
        this.handleAddRow();
      } else if (key === 'delete') {
        this.handleRemoveRow();
      } else {
        this.$emit('click', key);
      }
    },
    handleAddRow() {
      this.$emit("add");
      this.$emit('click', "add");
    },
    handleRemoveRow() {
      const checkList = this.value.filter((data) => data[this.checkedKey])
      this.$emit("input", this.value.filter((data) => !data[this.checkedKey]))
      this.$emit("delete", checkList);
      this.$emit('click', "delete", checkList);
    },
  }
}
</script>

<style scoped>

</style>
